import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=28f8429a&scoped=true&"
import script from "./Patient.vue?vue&type=script&lang=ts&"
export * from "./Patient.vue?vue&type=script&lang=ts&"
import style0 from "./Patient.vue?vue&type=style&index=0&id=28f8429a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8429a",
  null
  
)

export default component.exports